import {createApp} from 'vue'
import App from './App.vue'
import router from './router';

import {IonicVue} from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import 'firebaseui/dist/firebaseui.css'

import "@/assets/main.scss";

import store from './store'
import createI18nPlugin from './i18n'

import containerRegistrationFunction from "@/dependeciesInjections";
import {Container} from "@/utils/Container";
import {FirebaseAppService} from "@/services/FirebaseAppService";

import "./registerServiceWorker";

import OnLongPress from "@/directive/on-long-press";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

containerRegistrationFunction();


Container.get<FirebaseAppService>('FirebaseAppService');

const i18n = createI18nPlugin();

Bugsnag.start({
    apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
    enabledReleaseStages: ["production"],
    releaseStage: process.env.VUE_APP_BUGSNAG_STAGE,
    plugins: [new BugsnagPluginVue()]
})

const bugsnagVue = Bugsnag.getPlugin('vue');

if (!bugsnagVue) {
    throw new Error("Could not initialize bugsnag")
}

const app = createApp(App)
    .use(i18n)
    .use(store)
    .use(IonicVue)
    .use(bugsnagVue)
    .use(router);


app.directive('long-press', OnLongPress)

router.isReady().then(() => {
  app.mount('#app');
});

